import React from 'react';
import { Text } from 'react-native';
import * as defaultStyles from '../../../assets/defaultStyles';

const ArchivoText = (props) => {
  const fontWeight = () => {
    if (props.bold && props.italic)
      return { fontFamily: 'archivo-bold-italic' };
    if (props.bold) return { fontFamily: 'archivo-bold' };
    if (props.semibold) return { fontFamily: 'archivo-semibold' };
    if (props.medium) return { fontFamily: 'archivo-medium' };
    if (props.italic) return { fontFamily: 'archivo-italic' };
    return { fontFamily: 'archivo-regular' };
  };

  const color = () => {
    if (props.white) return { color: defaultStyles.white };
    if (props.red) return { color: defaultStyles.red };
    if (props.green) return { color: defaultStyles.green };
    if (props.primary) return { color: defaultStyles.primary };
    return {};
  };

  return (
    <Text {...props} style={[fontWeight(), color(), props.style]}>
      {props.children}
    </Text>
  );
};

export default ArchivoText;
